import classNames from "classnames";
import styles from "./styles.module.scss";
import { useContext, useState } from "react";
import { ContractContext } from "../../../../providers/contract";
import { useTranslation } from "react-i18next";
import DataCard from "./DataCard";
import FloatingTextarea from "./FloatingTextArea";
import EditDataModal from "./EditDataModal";

const OperationMetadata = () => {
  const { contract } = useContext(ContractContext);
  const { t } = useTranslation();
  const [showEditModal, setShowEditModal] = useState(false);

  const handleEditClick = () => {
    setShowEditModal(true);
  };

  return (
    <div className={classNames(styles.card, styles.container)}>
      <div className={styles.headerContainer}>
        <h2 className={styles.header}>{t("lbl_operation_metadata")}</h2>
        <p className={styles.link} onClick={handleEditClick}>
          {t("lbl_amendment")}
        </p>
      </div>
      <div className={styles.dataContainer}>
        <div className={styles.filtersContainer}>
          <div className={styles.filterRow}>
            <DataCard
              title={t("lbl_category")}
              value={contract?.operationsMetaData?.category || "-"}
            />
            <DataCard
              title={t("lbl_operational_status")}
              value={contract?.operationsMetaData?.operationStatus || "-"}
            />
            <DataCard
              title={t("lbl_payment_method")}
              value={contract?.operationsMetaData?.cashIn || "-"}
            />
            <DataCard
              title={t("lbl_operational_type")}
              value={contract?.operationsMetaData?.operationalType || "-"}
            />
            <DataCard
              title={t("lbl_escalation")}
              value={contract?.operationsMetaData?.escalation || "-"}
            />
            <DataCard
              title={t("lbl_operation_result")}
              value={contract?.operationsMetaData?.operationResult || "-"}
            />

            <DataCard
              title={t("lbl_commission_bearer")}
              value={contract?.operationsMetaData?.commisionBearer || "-"}
            />
            <DataCard
              title={t("lbl_shipping_company")}
              value={contract?.operationsMetaData?.shippingCompany || "-"}
            />
            <DataCard
              title={t("lbl_transfer")}
              value={contract?.operationsMetaData?.cashOut || "-"}
            />
            <DataCard
              title={t("lbl_cash_out_system")}
              value={contract?.operationsMetaData?.cashOutOutSystem || "-"}
            />
            <DataCard
              title={t("lbl_cash_out_out_type")}
              value={contract?.operationsMetaData?.cashOutOutType || "-"}
            />
          </div>
        </div>
        <div className={styles.commentsContainer}>
          <FloatingTextarea
            label="ملاحظات"
            value={contract?.operationsMetaData?.comments || "-"}
            rows={5}
            dir="rtl"
            disabled
          />
        </div>
      </div>
      <EditDataModal
        modalOpen={showEditModal}
        handleClose={() => setShowEditModal(false)}
      />
    </div>
  );
};

export default OperationMetadata;
